<div class="login-page">
  <!-- Language selector (top right) -->
  <div class="login-page__lang-selector">
    <button
      type="button"
      class="login-page__lang-btn"
      (click)="langMenu.toggle($event)"
    >
      <i class="fas fa-globe"></i>
      <span>{{ currentLang }}</span>
      <i class="fas fa-chevron-down"></i>
    </button>
    <p-menu
      #langMenu
      [model]="languageItems"
      [popup]="true"
      appendTo="body"
    ></p-menu>
  </div>

  <!-- Background decoration -->
  <div class="login-page__background">
    <div class="login-page__pattern"></div>
  </div>

  <!-- Main content -->
  <div class="login-page__container">
    <!-- Left side: Branding -->
    <div class="login-page__branding">
      <div class="login-page__branding-content">
        <div class="login-page__logo">
          <img
            src="assets/images/branding/virtualcenter-logo-horizontal-blanco.png"
            alt="Virtualcenter"
            class="login-page__logo-img"
          />
        </div>
        <p class="login-page__brand-tagline">
          {{ "LOGIN.TAGLINE" | translate }}
        </p>

        <ul class="login-page__features">
          <li>
            <i class="fas fa-calendar-check"></i>
            <span>{{ "LOGIN.FEATURE_1" | translate }}</span>
          </li>
          <li>
            <i class="fas fa-users"></i>
            <span>{{ "LOGIN.FEATURE_2" | translate }}</span>
          </li>
          <li>
            <i class="fas fa-chart-line"></i>
            <span>{{ "LOGIN.FEATURE_3" | translate }}</span>
          </li>
        </ul>
      </div>
    </div>

    <!-- Right side: Login form -->
    <div class="login-page__form-section">
      <div class="login-card">
        <!-- Mobile logo (visible only on mobile) -->
        <div class="login-card__mobile-logo">
          <img
            src="assets/images/branding/virtualcenter-logo-horizontal-negro.png"
            alt="Virtualcenter"
            class="login-card__mobile-logo-img"
          />
        </div>

        <!-- Card header -->
        <div class="login-card__header">
          <h1 class="login-card__title">{{ "LOGIN.TITLE" | translate }}</h1>
          <p class="login-card__subtitle">
            {{ "LOGIN.REQUIRED_PROFESSIONAL" | translate }}
          </p>
        </div>

        <!-- Login form -->
        <form class="login-card__form" (ngSubmit)="login()">
          <!-- Email field -->
          <div class="vc-form-field">
            <label class="vc-form-field__label" for="email">
              {{ "COMMON.EMAIL" | translate }}
            </label>
            <span class="p-input-icon-left login-card__input-wrapper">
              <i class="fas fa-envelope"></i>
              <input
                pInputText
                id="email"
                name="email"
                type="email"
                [(ngModel)]="username"
                [placeholder]="'ejemplo@clinica.com'"
                class="login-card__input"
                autocomplete="email"
              />
            </span>
          </div>

          <!-- Password field -->
          <div class="vc-form-field">
            <label class="vc-form-field__label" for="password">
              {{ "COMMON.PASSWORD" | translate }}
            </label>
            <p-password
              id="password"
              name="password"
              [(ngModel)]="password"
              [feedback]="false"
              [toggleMask]="true"
              placeholder="••••••••"
              styleClass="login-card__password"
              inputStyleClass="login-card__input"
              autocomplete="current-password"
            ></p-password>
          </div>

          <!-- Remember me & Forgot password -->
          <div class="login-card__options">
            <div class="login-card__remember">
              <p-checkbox inputId="remember" [binary]="true"></p-checkbox>
              <label for="remember" class="login-card__remember-label">
                {{ "LOGIN.REMEMBER_ME" | translate }}
              </label>
            </div>
            <a routerLink="/forgot-password" class="login-card__forgot-link">
              {{ "LOGIN.FORGOT_PASSWORD" | translate }}
            </a>
          </div>

          <!-- Submit button -->
          <button
            pButton
            type="submit"
            [label]="'LOGIN.ACTION' | translate"
            class="login-card__submit"
            icon="fas fa-sign-in-alt"
            iconPos="right"
          ></button>

          <div class="login-card__social" *ngIf="googleConfigured">
            <div class="login-card__divider">
              <span>{{ "LOGIN.OR_CONTINUE_WITH" | translate }}</span>
            </div>
            <div
              class="login-card__google-loading"
              *ngIf="googleLoading"
            >
              {{ "COMMON.LOADING" | translate }}...
            </div>
            <div
              #googleButtonContainer
              class="login-card__google-button"
            ></div>
            <p
              class="login-card__google-unavailable"
              *ngIf="!googleLoading && !googleAvailable"
            >
              {{ "LOGIN.GOOGLE_UNAVAILABLE" | translate }}
            </p>
          </div>
        </form>

        <!-- Card footer -->
        <div class="login-card__footer">
          <p class="login-card__footer-text">
            {{ "LOGIN.NEED_HELP" | translate }}
            <a
              href="mailto:soporte@virtualcenter.com"
              class="login-card__support-link"
            >
              {{ "LOGIN.CONTACT_SUPPORT" | translate }}
            </a>
          </p>
        </div>
      </div>

      <!-- Footer branding -->
      <div class="login-page__footer">
        <span>© {{currentYear}} Virtualcenter</span>
        <span class="login-page__footer-separator">•</span>
        <span>v1.0.0</span>
      </div>
    </div>
  </div>
</div>
